module.exports = __webpack_public_path__ + "static/img/Belanda.cded715.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/landmark/Belanda.png
// module id = XSS8
// module chunks = 1